import { Component, OnInit } from '@angular/core';

import { AppService } from '../../services/app.service';
import { ApiConnectionService } from '../../services/core/api-connection.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

import { DomSanitizer } from '@angular/platform-browser';
import { ConfigService } from 'src/app/services/core/config.service';
import { environment } from 'src/environments/environment';

import { AuthenticationService } from 'src/app/services/core/authentication.service';

@Component({
  selector: 'app-module-index',
  templateUrl: './module-index.component.html',
  styleUrls: ['./module-index.component.scss']
})
export class ModuleIndexComponent implements OnInit {

  chapter: any = {};
  name = '';

  lessons: any = [];
  choiceAssignments: any = [];

  choiceAssignmentTitle = '';

  sectionIntro = '';
  systemTitle = '';
  introImage = '';
  systemSlogan = '';
  salesWebsite = '';

  currentUser;

  constructor(
    public appService: AppService,
    public dom: DomSanitizer,
    private route: ActivatedRoute,
    public api: ApiConnectionService,
    private location: Location,
    private config: ConfigService,
    private ngxLoader: NgxUiLoaderService,
    private authService: AuthenticationService
  ) {
    let self = this;

    self.appService.setDefaultAuthor();
    self.appService.setPageTitle('');
    this.appService.setPageDescription('');

    self.authService.data.subscribe(data => {
      if (Object.keys(data).length) {
        self.currentUser = data;
        self.appService.getActivities(self.currentUser['id']);
      } else {
        self.currentUser = false;
      }
    });

    self.choiceAssignmentTitle = config.get('choice_assignments_title');

    this.sectionIntro = config.get('intro_text');
    this.systemTitle = config.get('title');
    this.introImage = this.config.get('intro_image_url');
    this.salesWebsite = this.config.get('sales_website');
    this.systemSlogan = this.config.get('slogan');

    this.appService.setShowCheckRequestAlert();
  }

  ngOnInit(): void {
    this.appService.navActive();
    let self = this;

    this.ngxLoader.start();

    self.fetchChapterData();
  }

  fetchChapterData() {
    const slug = this.config.get("frontModule");
    const self = this;

    this.api.read('chapters/slug/' + slug + '').then((response) => {
      self.name = response['name'];
      self.appService.setPageTitle(response['name']);
      self.chapter = response;

      for (let key in self.chapter['lessons']) {
        if (self.chapter['lessons'][key]['type'] === 'CHOICE_ASSIGNMENT') {
          self.choiceAssignments.push(self.chapter['lessons'][key]);
        }
        else if (self.chapter['lessons'][key]['type'] === 'LESSON') {
          self.lessons.push(self.chapter['lessons'][key]);
        }
      }

      self.ngxLoader.stop();
    }).catch((err) => {
      //error could be due to invalid bearer token after logout, refetch data after timeout
      setTimeout(() => {
        this.fetchChapterData();
      }, 500);
    });
  }

  text(lesson) {
    return this.dom.bypassSecurityTrustHtml(lesson);
  }
}
